import { STATUS_CHANGE_REQUESTS, STATUS_CHANGE_FILTERS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const normalizeArray = (value) => (Array.isArray(value) ? value : []);

const isPlaceholderValue = (value) => {
  if (value === null || value === undefined) return false;
  const text = String(value).trim();
  return (
    text === ''
    || text === '<REAL_PROJECT_ID>'
    || text === '<STATUS>'
    || text === 'YYYY-MM-DD'
  );
};

const normalizeParamValue = (value) => {
  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== null && item !== undefined && item !== '' && !isPlaceholderValue(item))
      .join(',');
  }
  if (isPlaceholderValue(value)) return '';
  return value;
};

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const normalizedValue = normalizeParamValue(value);
    if (normalizedValue === null || normalizedValue === undefined || normalizedValue === '') return;
    searchParams.append(key, normalizedValue);
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

export const getStatusChangeRequests = ({
  projectId,
  projectName,
  projectType,
  vertical,
  employeeId,
  assignedToMe,
  requestStatus,
  requestedBy,
  requestedDate,
  approvedDate,
  requestedDateFrom,
  requestedDateTo,
  approvedDateFrom,
  approvedDateTo,
  cacheBust,
  page,
  limit,
} = {}) => ({
  url: `${STATUS_CHANGE_REQUESTS}${buildQueryString({
    project_id: projectId,
    employeeId: employeeId,
    project_name: projectName,
    project_type: projectType,
    vertical,
    assigned_to_me: assignedToMe ? 'true' : undefined,
    request_status: requestStatus,
    requested_by: requestedBy,
    requested_date: requestedDate,
    approved_date: approvedDate,
    requested_date_from: requestedDateFrom,
    requested_date_to: requestedDateTo,
    approved_date_from: approvedDateFrom,
    approved_date_to: approvedDateTo,
    cache_bust: cacheBust,
    page,
    limit,
  })}`,
  method: 'get',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getStatusChangeFilterOptions = (
  filterKey,
  __options = {},
) => ({
  url: `${STATUS_CHANGE_FILTERS}/${filterKey}${buildQueryString({
  })}`,
  method: 'get',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const deleteStatusChangeRequest = (statusChangeId, options = {}) => ({
  url: `${STATUS_CHANGE_REQUESTS}/${statusChangeId}${buildQueryString({
    logged_in_emp_id: options.loggedInEmpId,
    employeeId: options.employeeId,
  })}`,
  method: 'delete',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getStatusChangeRequestById = (statusChangeId, options = {}) => ({
  url: `${STATUS_CHANGE_REQUESTS}/${statusChangeId}${buildQueryString({
    logged_in_emp_id: options.loggedInEmpId,
    employeeId: options.employeeId,
  })}`,
  method: 'get',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const approveStatusChangeRequest = (statusChangeId, payload) => ({
  url: `${STATUS_CHANGE_REQUESTS}/${statusChangeId}/approval`,
  method: 'post',
  payload,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getStatusApprovalPendingCount = () => ({
  url: `${STATUS_CHANGE_REQUESTS}/approval-pending`,
  method: 'get',
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const listStatusChangeRequestHistory = (payload) => ({
  url: STATUS_CHANGE_REQUESTS,
  method: 'post',
  payload,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const createStatusChangeRequest = (payload) => ({
  url: STATUS_CHANGE_REQUESTS,
  method: 'post',
  payload,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const updateStatusChangeRequest = (statusChangeId, payload) => ({
  url: `${STATUS_CHANGE_REQUESTS}/${statusChangeId}`,
  method: 'put',
  payload,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const normalizeFilterSelection = (values = []) =>
  normalizeArray(values).map((item) => (
    typeof item === 'object' ? item.value ?? item.name ?? item.label : item
  ));
